/*
 * Sectionboard search control
*/
rs.module("applicationmenu/sectionboard/search",

    ["ui/framework/client-templates"],

    function (clientTemplates) {

        //
        // Module initialization
        //
        function initialize(jsSelectors, skeletonTemplateKey, searchAjaxUrl, advancedSearchAjaxUrl) {

            var skeletonTemplate = clientTemplates.render(skeletonTemplateKey);
            var searchContainer = $.js(jsSelectors.searchContainer);

            // Search - add button click event
            searchContainer.js(jsSelectors.searchButton).click(function () {
                $(this).blur();
                initiateSearch(jsSelectors, skeletonTemplate, searchAjaxUrl);
            });

            // Advanced Search (may or may not exist depending on menu section)
            if (advancedSearchAjaxUrl) {

                // add link click event
                var advancedSearchLink = searchContainer.js(jsSelectors.advancedSearchLink, { required: false });
                advancedSearchLink.click(function () {
                    redirectToAdvancedSearch(jsSelectors, advancedSearchAjaxUrl);
                });

                // Handle Shift-Enter press within search input
                searchContainer.js(jsSelectors.searchInput).on("keydown",
                    function (event) {
                        if (event.keyCode == 13 && event.shiftKey) {
                            redirectToAdvancedSearch(jsSelectors, advancedSearchAjaxUrl);
                            return false;
                        }
                    }
                );
            }
        }

        //
        // Initiate the search
        //
        function initiateSearch(jsSelectors, skeletonTemplate, searchAjaxUrl) {

            var container = $.js(jsSelectors.searchContainer);
            var searchInput = container.js(jsSelectors.searchInput);
            var results = container.js(jsSelectors.searchResults);

            results.empty();
            results.append($(skeletonTemplate));

            var query = searchInput.val().trim();

            $.get(

                searchAjaxUrl,

                {
                    "query": query
                },

                function (data) {
                    results.html(data);
                }
            );
        }

        //
        // Redirect to advanced search
        //
        function redirectToAdvancedSearch(jsSelectors, advancedSearchAjaxUrl) {

            var searchContainer = $.js(jsSelectors.searchContainer);
            var searchInput = searchContainer.js(jsSelectors.searchInput);
            var query = searchInput.val().trim();

            $.getJSON(

                advancedSearchAjaxUrl,

                {
                    "query": query
                },

                function (data) {
                    window.location.href = data.searchUrl;
                }
            );
        }

        //
        // Exported function that individual search results will call when they are loaded
        //
        function searchCompleted(jsSelectors, cssClasses) {

            // Hook up event listener to expand/collapse the sub links section
            $.js(jsSelectors.subLinksToggle, { multiple: true, required: false }).click(function () {

                $(this).toggleClass(cssClasses.active);
                $(this).closest(`[data-js=${jsSelectors.searchResult}]`).js(jsSelectors.subLinksSection).slideToggle(200);

                // Since the toggle is inside the main search result, we need to return false to stop propagation so it doesn't redirect 
                return false;
            });
        }

        // Exported public API
        var exports = {
            initialize,
            searchCompleted
        };

        return exports;
    }
);